/*
 * Module for configuring passkeys
*/

rs.module("user/account/passkeys",

    [
        "ui/framework/passkeys",
        "controls/components/event-banner"
    ],

    function (passkeys, eventBanner) {

        //
        // Initialize
        //
        function initialize(jsSelectors, paths) {

            // Initialize passkey registration flow
            passkeys.initializeRegistration({
                registerButton: jsSelectors.registerButton,
            }, paths, function (error) {
                eventBanner.removeAllMessages();
                eventBanner.addErrorMessages(error);
            });
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);